import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { IDialogMessage } from 'src/app/@amiga-pyme/components/ami-dialog-message/ami-dialog-message.interface';
import { IBranchStore } from 'src/app/pages/gestion/branch-stores/branch-store.interface';
import { InventoryToStockService } from '../inventory-to-stock.service';
import { IWarehouseProduct } from 'src/app/pages/gestion/warehouse/warehouse-products.interface';
import { IRegulatedProduct } from 'src/app/pages/gestion/regulated-products/regulated-product.interface';
import { IProductUnregulated } from 'src/app/pages/gestion/products-unregulated/product-unregulated.interface';
const TYPE_PRODUCT = {
  REGULATED: 1,
  UNREGULATED: 2
};
import { BranchStoreSelected } from 'src/app/pages/gestion/branch-stores/components/details/branch-store-details.component';

@Component({
  selector: 'pg-inventory-to-stock',
  templateUrl: './inventory-to-stock.component.html'
})
export class InventoryToStockComponent implements OnInit {
  message: IDialogMessage;
  PRODUCTS_TYPES_NAMES_FOR_DROPDOWN = [
    { label: 'REGULADOS', value: 'REGULATED' },
    { label: 'NO REGULADOS', value: 'UNREGULATED' }
  ];
  fg: FormGroup;
  meunitMeasureProductssage: IDialogMessage;
  quantityWarehouseMax: number;
  unitMeasureWarehouse: string;
  unitMeasureProduct: string;
  validatorsBaseQuantity = [Validators.required, Validators.min(1)];
  branchStoreSelected = new BranchStoreSelected('Sucursal Destino');
  isBranchStoreSelected = false;
  select = {
    product: {
      type: 'single',
      REGULATED: {
        openDialog: false,
        id: null
      },
      UNREGULATED: {
        openDialog: false,
        id: null
      },
      data: null
    },
    productOfWarehouse: {
      type: 'single',
      openDialog: false,
      id: null
    }
  };
  constructor(
    private fb: FormBuilder,
    private inventoryToStockService: InventoryToStockService
  ) {}

  ngOnInit() {
    this.fg = this.fb.group({
      productOfWarehouse: [null, Validators.required],
      quantityProductOfWarehouse: [1, this.validatorsBaseQuantity],
      unitsInProductWarehouse: [1, this.validatorsBaseQuantity],
      equivalentQuantity: [1, this.validatorsBaseQuantity]
    });

    this.fg
      .get('quantityProductOfWarehouse')
      .valueChanges.subscribe((value) => {
        const units = this.fg.get('unitsInProductWarehouse').value;
        const equivalentQuantity = value * units;
        this.fg.get('equivalentQuantity').setValue(equivalentQuantity);
      });

    this.fg.get('unitsInProductWarehouse').valueChanges.subscribe((value) => {
      const quantity = this.fg.get('quantityProductOfWarehouse').value;
      const equivalentQuantity = value * quantity;
      this.fg.get('equivalentQuantity').setValue(equivalentQuantity);
    });
  }

  onSelectedproductOfWarehouse(row: IWarehouseProduct) {
    if (row) {
      this.fg.controls.productOfWarehouse.setValue(
        `${row.productOfProviderDescription} / ${row.unitMeasureDescription}`
      );
      this.select.productOfWarehouse.id = row.id;
      this.quantityWarehouseMax = row.quantity;
      this.unitMeasureWarehouse = row.unitMeasureDescription;
      this.fg
        .get('quantityProductOfWarehouse')
        .setValidators([
          ...this.validatorsBaseQuantity,
          Validators.max(this.quantityWarehouseMax)
        ]);
    }
    this.select.productOfWarehouse.openDialog = false;
  }

  onSelectedBranchStore(event: any) {
    this.isBranchStoreSelected = true;
    this.branchStoreSelected.onSelect(event);
  }

  findPurchaseFormatOfProduct(
    product: IRegulatedProduct | IProductUnregulated
  ): string {
    let foundPurchaseFormat;

    const productFormats = product.format;

    Object.keys(productFormats).forEach((formatName) => {
      const { isFormatPurchase } = productFormats[formatName];
      if (isFormatPurchase && isFormatPurchase === true) {
        foundPurchaseFormat = formatName;
        return;
      }
    });

    return foundPurchaseFormat;
  }

  async onSubmit() {
    const itemToRegister = {
      warehouseId: this.select.productOfWarehouse.id,
      branchStoreId: this.branchStoreSelected.getId(),
      warehouseQuantity: this.fg.get('quantityProductOfWarehouse').value,
      productQuantity: this.fg.get('equivalentQuantity').value,
      productMinQuantity: this.fg.get('unitsInProductWarehouse').value
    };

    this.message = { message: 'Registrando producto en almacén' };
    this.message = await this.inventoryToStockService.register(itemToRegister);
    const status = this.message.status;
    if (status === 201) {
      setTimeout(() => {
        this.fg.reset();
        this.branchStoreSelected.onReset();
        this.isBranchStoreSelected = false;
        this.message = null;
        location.reload();
      }, 1500);
    }
  }
}
